export default "__VITE_ASSET__BbaPwNoj__"